/* tslint:disable */
/* eslint-disable */
/* @relayHash 007ede2cfbe8007879a7a332f30594c2 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type UserRegistrationInput = {
    email: string;
    password?: string | null;
    marketingOptIn?: boolean | null;
    authHash: string;
    cookieDomain?: string | null;
    guestCheckoutUserToken?: string | null;
    clientMutationId?: string | null;
};
export type registrationMutationVariables = {
    input: UserRegistrationInput;
};
export type registrationMutationResponse = {
    readonly userRegistration: {
        readonly emailToken: string | null;
        readonly user: {
            readonly serviceId: string | null;
            readonly userId: string | null;
            readonly createdDate: string | null;
            readonly isVerifiedTrade: boolean | null;
            readonly verifiedTradeStatus: string | null;
            readonly profile: {
                readonly email: string | null;
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly currency: Currency | null;
                readonly measurementUnit: MeasurementUnit | null;
            } | null;
            readonly " $fragmentRefs": FragmentRefs<"userTradeStatus_user">;
        } | null;
        readonly userToken: string | null;
        readonly userId: string | null;
        readonly isNewUser: boolean | null;
    } | null;
};
export type registrationMutation = {
    readonly response: registrationMutationResponse;
    readonly variables: registrationMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UserRegistrationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "emailToken",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": "userId",
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdDate",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVerifiedTrade",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "verifiedTradeStatus",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "profile",
  "storageKey": null,
  "args": null,
  "concreteType": "Profile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lastName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "measurementUnit",
      "args": null,
      "storageKey": null
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVip",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userToken",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userId",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isNewUser",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "registrationMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "userRegistration",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UserRegistrationPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "InlineDataFragmentSpread",
                "name": "userTradeStatus_user",
                "selections": [
                  (v9/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          },
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "registrationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "userRegistration",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UserRegistrationPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "registrationMutation",
    "id": "ferrum/262.0.0-2020-04-28T16:33:21.478Z/registrationMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '51a41d63fdc4df0ab165af35171b6756';
export default node;
